import { Box, Typography } from "@mui/material";
import { FormField } from "@components/FormEngine/types";
import { Fragment, ReactNode } from "react";

export interface FieldWrapperProps {
  field: FormField;
  children: ReactNode;
}

export const DefaultFieldWrapper = ({ field, children }: FieldWrapperProps) => {
  return (
    <Fragment key={field.name}>
      {children}
    </Fragment>
  );
};

export const PaperworkFieldWrapper: React.FC<FieldWrapperProps> = ({ field, children }) => {
  return (
    <Box>
      <Box sx={{ mb: 1 }}>
        <Typography variant="h6" component="h2" color="primary.main">
          {field.title}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {field.description}
        </Typography>
      </Box>
      {children}
    </Box>
  );
};